import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=1abb397c&scoped=true"
var script = {}
import style0 from "./Card.vue?vue&type=style&index=0&id=1abb397c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abb397c",
  null
  
)

export default component.exports